import Link from "next/link";
import { MdKeyboardArrowRight } from "react-icons/md";
import { useRouter } from "next/router";

const BreadCrumb = ({addPadding = true, ArrayOfBreadCrumb}) => {
  const {locale} = useRouter();
  
  return (
    <div className={`max-w-[1600px] ${addPadding ? "px-6" : "px-4 lg:px-0 "} lg:mx-auto my-5`}>
      {ArrayOfBreadCrumb?.length ? (
        <div className="flex items-center p-2 bg-white rounded-md">
          <Link href="/" className="duration-200 text-gray-400">
            {locale === "en" ? "Home" : "الرئيسية"}
          </Link>
          <MdKeyboardArrowRight
            size="20px"
            className={`mx-2 ${
              locale === "en" ? "rotate-0" : "rotate-180"
            }`}
          />

          {ArrayOfBreadCrumb.map((item, i) => {
            const link = ArrayOfBreadCrumb?.slice(0, i + 1)
              .map((item) => item?.url_key)
              ?.join("/");
            return (
              <div key={i} className="flex items-center justify-center">
                {ArrayOfBreadCrumb?.length - 1 > i ? (
                  <Link
                    href={`/${link}`}
                    className={`duration-200 ${item?.name_EN == "Delivery" && "text-blue"}`}
                  >
                    {locale == "en" ? item?.name_EN : item?.name_AR}
                  </Link>
                ) : (
                  <h1 className={`duration-200 ${item?.name_EN == "Delivery" && "text-blue font-bold"}`}>{locale == "en" ? item?.name_EN : item?.name_AR}</h1>
                )}

                {ArrayOfBreadCrumb.length - 1 > i && (
                  <MdKeyboardArrowRight
                    size="20px"
                    className={`mx-2 ${
                      locale === "en" ? "rotate-0" : "rotate-180"
                    }`}
                  />
                )}
              </div>
            );
          })}

        </div>
      ) : null}
    </div>
  )
}

export default BreadCrumb